import { useState, useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useAxios from './useAxios';
import Constants from '../Constants';
import { debounce } from '../utils/helper';

const useTeamForm = ({ selectedTeam, onSubmit }) => {
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const { getData } = useAxios();

    const onSearch = useRef(debounce((val) => setSearch(val), 500)).current;

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await getData(`${Constants.ApiUrl.user.getUsers}?searchText=${search}&limit=${10}`);
                if (response.success) {
                    setUsers(response.data.users);
                }
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, [getData, search]);

    const formik = useFormik({
        initialValues: {
            name: selectedTeam?.name ?? '',
            description: selectedTeam?.description ?? '',
            userIds: selectedTeam?.userIds ?? [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            name: Yup.string().required('Name is required'),
        }),
        onSubmit: (values) => {
            const payload = {
                ...values,
                userIds: values.userIds.map((user) => user._id),
            };
            onSubmit(payload);
        },
    });

    return { formik, users, onSearch };
};

export default useTeamForm;
